import React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import { useQuery } from '@apollo/client/react/hooks';

import NotFound from 'four-nets/errors/404/not-found';

import query, { ReplyRedirectQuery, ReplyRedirectQueryVariables } from './reply-redirect.graphql';

const ReplyRedirect: React.FC<RouteComponentProps<{ token: string }>> = ({
    match: {
        params: { token },
    },
}) => {
    const { data, loading } = useQuery<ReplyRedirectQuery, ReplyRedirectQueryVariables>(query, {
        variables: { token },
    });
    return data && data.buyerReplyRedirectUrl ? (
        <Redirect to={data.buyerReplyRedirectUrl} />
    ) : loading ? null : (
        <NotFound />
    );
};

export default ReplyRedirect;
